/**
 * SDK protocol/semver identifier sent on every collect request.
 * Collect protocol identifier sent on every collect request (`v: 1` remains the schema).
 */
export const SDK_VERSION = '1.0.0';
